import { ViolationHistory } from '../../../../../models/entities/violation-history';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CapitalizePipeModule } from '../../../../../pipes/format/capitalize.module';

export interface ViolationHistoryTableDialogInput {
    history: ViolationHistory;
}

@Component({
    selector: 'app-violation-history-table-dialog',
    templateUrl: './violation-history-table-dialog.component.html',
    standalone: true,
    imports: [
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        CapitalizePipeModule,
    ],
})
export class ViolationHistoryTableDialogComponent
{
    constructor(
            @Inject(MAT_DIALOG_DATA) public data: ViolationHistoryTableDialogInput,
    ) {
    }
}
